import React from 'react';
import ReactDOM from 'react-dom';

const SpinnerComponent = () => {
    return (
        <div className="lv-circles lv-mid lg">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
};

export default SpinnerComponent;